import { scheduledJobService } from '_services';
import { session } from '_helpers';
import { ACTIONS_SCHEDULED_JOB } from '_constants/scheduledJob.constants';
import alertActions from './alert.actions';

export const receiveScheduledJobs = (scheduledJobs) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < scheduledJobs.length; i++) {
    byIdObjectToDispatch[scheduledJobs[i].scheduledJobID] = scheduledJobs[i];
  }

  return {
    type: ACTIONS_SCHEDULED_JOB.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteScheduledJob = (scheduledJobId) => ({
  type: ACTIONS_SCHEDULED_JOB.DELETE,
  byId: { [scheduledJobId]: null }
});

const getScheduledJobs = (accountID) => async (dispatch) => {
  try {
    const resp = await scheduledJobService.getAll(accountID);
    if (resp?.[0]?.scheduledJobID) {
      dispatch(receiveScheduledJobs(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving scheduled jobs.', e));
  }
  return null;
};

const getScheduledJob = (scheduledJobID) => async (dispatch) => {
  try {
    const resp = await scheduledJobService.getById(scheduledJobID);
    if (resp?.scheduledJobID) {
      dispatch(receiveScheduledJobs([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving scheduled job #${scheduledJobID}.`, e));
  }
  return null;
};

const addScheduledJob = (scheduledJob) => async (dispatch) => {
  try {
    const resp = await scheduledJobService.create(scheduledJob);
    if (resp?.scheduledJobID) {
      dispatch(receiveScheduledJobs([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updScheduledJob = (scheduledJob) => async (dispatch) => {
  try {
    const resp = await scheduledJobService.update(scheduledJob);
    if (resp?.scheduledJobID) {
      dispatch(receiveScheduledJobs([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delScheduledJob = (scheduledJobID) => async (dispatch) => {
  try {
    const resp = await scheduledJobService.delete(scheduledJobID);
    if (resp?.scheduledJobID) {
      dispatch(deleteScheduledJob(resp.scheduledJobID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing scheduled job #${scheduledJobID}.`, e));
  }
  return null;
};

const scheduledJobActions = {
  getScheduledJobs,
  getScheduledJob,
  addScheduledJob,
  updScheduledJob,
  delScheduledJob
};

export default scheduledJobActions;
